import React from 'react';

export default function EvidenceFooterNote({ icon, children }) {
  return (
    <div style={{ marginTop: 8, fontSize: 12, color: '#6B778C', display: 'flex', alignItems: 'center', gap: 6 }}>
      {icon}
      {children}
    </div>
  );
}
